import React, { FC, useEffect } from "react";
import Accordion from "../../../../components/accordion/Accordion";
import ApplicationForm from "./components/ApplicationForm/ApplicationForm";
import { useAppDispatch, useAppSelector } from "../../../../hooks/redux-hooks";
import { selectContestsState } from "../../../../store/slices/contests";
import { applicationByContest } from "../../../../api/asyncThuncks/contestsCards";
import { useParams } from "react-router-dom";
import Quill from "../../../../components/common/quill/Quill";

export const Application: FC = () => {
  const { contestByUrl } = useAppSelector(selectContestsState);
  const dispatch = useAppDispatch();
  const { publicUrl } = useParams();

  // useEffect(() => {
  //   if (slug) dispatch(contestCardByPublicUrl(slug));
  // }, [slug]);

  useEffect(() => {
    if (publicUrl) dispatch(applicationByContest(publicUrl));
  }, [dispatch, publicUrl]);
  console.log(contestByUrl.application?.accordions);
  return (
    <div className="w-screen md:max-w-[1000px]">
      <div className="w-full px-5 pt-9 pb-14 mt-2 bg-white md:px-0">
        <h3 className="pb-5 text-2xl font-bold">
          {contestByUrl.application?.applicationTitle}
        </h3>
        <p className="pb-10 text-base leading-7">
          <Quill
            text={contestByUrl.application?.applicationDescription}
            className={"winner"}
          />
        </p>
        <div className="flex flex-col items-center justify-center w-full">
          <div className="pb-10">
            <Accordion accordions={contestByUrl.application?.accordions} />
          </div>
          <ApplicationForm />
        </div>
      </div>
    </div>
  );
};

export default Application;
